/*
 * cs-cart-agree-gate.js — Cerrajería Santiago
 * ---------------------------------------------------------------------------
 * Hace obligatorio el checkbox de términos y condiciones del drawer del
 * carrito: si no está marcado, bloquea el botón "Ver carrito" y muestra el
 * mensaje de error.
 *
 * Por qué no se reutiliza <hdt-block-required> del tema
 * - El gate nativo se engancha en un único evento: el `submit` del form
 *   CartDrawer-Form (ver assets/global.min.js, block_required_on_submit_fn).
 *   "Ver carrito" es un <a href> (sections/cart-drawer.liquid:137), no un
 *   submit, así que nunca lo dispara. Además el botón de checkout del drawer
 *   está comentado (:145-153), o sea que ese form ya no tiene ningún botón de
 *   submit y el gate nativo es código muerto en el drawer.
 * - <hdt-need-checked-to-use> tampoco sirve acá: hace
 *   closest("form").dispatchEvent(submit), y el botón está FUERA del form (el
 *   form abre y cierra en :42-47, los botones viven en .hdt-mini-cart__bottom).
 *   Encima hace toggleAttribute("disabled"), que un <a> ignora.
 *
 * Notas de implementación
 * - Todo por delegación en document, para sobrevivir a los re-render parciales
 *   que hace el tema sobre ref="cart-bottom" al cambiar cantidades. Mismo
 *   patrón que assets/cart-validation.js.
 * - El checkbox se busca por name dentro del drawer, no por su id global
 *   (CartDrawer-Form_agree), así el scope es el elemento <hdt-cart-drawer> y no
 *   el documento entero.
 * - Se reutiliza la clase nativa .is-uncheck del tema para el borde rojo del
 *   checkbox, en vez de duplicar ese estilo.
 * - Si el bloque `agree` no está en el drawer, no hace nada: el link funciona
 *   normal.
 */
(function () {
  'use strict';

  var DRAWER_TAG = 'hdt-cart-drawer';
  var LINK_SELECTOR = '[data-cs-agree-gate="ver-carrito"]';
  var CHECKBOX_SELECTOR = 'input[name="agree_checkbox"]';
  var ERROR_SELECTOR = '.cs-agree-gate__error';
  var HOST_TAG = 'hdt-block-required';

  // Clases de estado del tema (assets/hdt-cart-drawer.css + global.min.js).
  var CLASS_UNCHECK = 'is-uncheck';
  var CLASS_REQUIRED = 'is-required';

  /* ------------------------------------------------------------- contexto */

  /**
   * Resuelve el estado actual del DOM a partir del nodo clickeado. Se llama
   * fresco en cada interacción para no guardar referencias a nodos que el tema
   * pueda reemplazar en un re-render.
   */
  function getContext(node) {
    if (!node || !node.closest) return null;

    var drawer = node.closest(DRAWER_TAG);
    if (!drawer) return null;

    var checkbox = drawer.querySelector(CHECKBOX_SELECTOR);
    if (!checkbox) return null; // el bloque `agree` no está en el drawer

    return {
      drawer: drawer,
      checkbox: checkbox,
      host: checkbox.closest(HOST_TAG),
      error: drawer.querySelector(ERROR_SELECTOR)
    };
  }

  /* -------------------------------------------------------- errores en UI */

  function showError(ctx) {
    if (ctx.error) {
      ctx.error.hidden = false;
      if (ctx.error.id) {
        ctx.checkbox.setAttribute('aria-describedby', ctx.error.id);
      }
    }

    ctx.checkbox.setAttribute('aria-invalid', 'true');

    if (ctx.host) {
      // Mismo intercambio de clases que hace el gate nativo al fallar.
      ctx.host.classList.remove(CLASS_REQUIRED);
      ctx.host.classList.add(CLASS_UNCHECK);
    }

    var target = ctx.host || ctx.checkbox;
    if (target.scrollIntoView) {
      target.scrollIntoView({ block: 'nearest' });
    }
    try {
      ctx.checkbox.focus({ preventScroll: true });
    } catch (err) {
      ctx.checkbox.focus();
    }
  }

  function clearError(ctx) {
    if (ctx.error) ctx.error.hidden = true;

    ctx.checkbox.removeAttribute('aria-invalid');
    ctx.checkbox.removeAttribute('aria-describedby');

    // El tema ya saca .is-uncheck en su propio handler de change; lo hacemos
    // igual porque clearError también corre desde otros caminos.
    if (ctx.host) ctx.host.classList.remove(CLASS_UNCHECK);
  }

  /* ------------------------------------------------------------ listeners */

  // Captura en document para correr antes de cualquier handler del tema sobre
  // el link o sobre el drawer.
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var link = target.closest(LINK_SELECTOR);
      if (!link) return;

      var ctx = getContext(link);
      if (!ctx || ctx.checkbox.checked) return; // paso libre

      event.preventDefault();
      event.stopPropagation();

      showError(ctx);
    },
    true
  );

  // Cualquier cambio del checkbox limpia el error, igual que hace el tema con
  // su propio estado: si sólo limpiáramos al marcarlo, al desmarcar quedaría
  // el mensaje visible con el checkbox ya sin borde rojo.
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || target.name !== 'agree_checkbox') return;

    var ctx = getContext(target);
    if (!ctx) return;

    clearError(ctx);
  });
})();
